/**
 * The outcome milestones, in the order a student reaches them (Sep 11 2026).
 *
 * Each one asks the student to say where before it completes: which program,
 * which major, which internship, which role. The flag was checked against
 * `completionNoteRequired` on every completion in 365 days of P3's analytics
 * (the Four Layers inventory, section 4): "Started Working While Studying"
 * never requires a note, so it is not an outcome; "Landed My First Full-Time
 * Role" always does ("Could you share more about your role and industry?").
 *
 * Shared by the Worker's Milestones section and the sample, so the two cannot
 * name different outcomes.
 */
export const OUTCOME_MILESTONES = [
  "Started College or Post-Secondary Program",
  "Declared My Major/Focus",
  "Completed an Internship or Research Experience",
  "Landed My First Full-Time Role",
] as const;
